import { useCallback, useEffect, useState } from 'react';
import type { ObjectDiscussionChannel } from '@econtractor/types';
import { getObjectDiscussionUnread } from 'api/apiObjectDiscussion';
import { OBJECT_DISCUSSION_POLL_MS } from './useObjectDiscussion';

const useDiscussionUnread = (
    objectId: number,
    channel: ObjectDiscussionChannel,
    enabled: boolean,
) => {
    const [unreadCount, setUnreadCount] = useState(0);
    const clearUnread = useCallback(() => setUnreadCount(0), []);

    useEffect(() => {
        if (!enabled || !objectId) {
            setUnreadCount(0);
            return undefined;
        }

        let stop = false;
        const load = async () => {
            const data = await getObjectDiscussionUnread(channel, objectId);
            if (!stop && data) setUnreadCount(data.unreadCount);
        };

        void load();
        const timer = window.setInterval(() => {
            void load();
        }, OBJECT_DISCUSSION_POLL_MS);

        return () => {
            stop = true;
            window.clearInterval(timer);
        };
    }, [channel, enabled, objectId]);

    return { unreadCount, clearUnread };
};

export default useDiscussionUnread;
